import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'CLEAR LABELED DIAGRAMS.', 'STEP-BY-STEP BREAKDOWNS.', '❌/✅ COMPARISONS.', 'READY PRACTICE DRILLS.', 'CLEAR ASSESSMENT CRITERIA.', 'READY-TO-TEACH CLASSES.', 'BETTER CLASS PREPARATION.'];
const alreadyHave = ['You already have the bar tools, glassware and technique visuals.', 'You already have the classic cocktail specs and drink family maps.', 'You already have the advanced mixology and creative cocktail methods.', 'You already have the spirits charts, tasting grids and flavor profiles.', 'You already have the garnish sequences, menu tools and bar operations guides.', 'You already have the lesson plans, training programs and assessment rubrics.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-slate-200" data-id="element-68" data-mp="2164cnhlqda4r">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-69" data-mp="1wc062zgdn447">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#1F4D3A] mb-6 uppercase" data-id="element-70" data-mp="1v6bf7egpxdt9">
          You Don&apos;t Need More Scattered <span className="text-[#9C7726]" data-id="element-71" data-mp="203bijhm6o2go">Bartending Resources.</span>
        </h2>
        <p className="text-xl text-slate-700/80 mb-5" data-id="element-72" data-mp="1l6kfmydaw8mb">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-73" data-mp="1q6gobawy0o87">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-[#1F4D3A] tracking-wide" data-id="element-74" data-mp="1c7pazqpwn6l4">
              {need}
            </li>)}
        </ul>
        <div className="bg-[#FBF6EF] border border-slate-200 rounded-2xl p-8 text-lg text-slate-700 space-y-2 text-left sm:text-center" data-id="element-75" data-mp="1h7v5rfrh197f">
          <p className="mb-4" data-id="element-76" data-mp="3bkbb8ecg0jb8">
            With BARTENDING &amp; MIXOLOGY INSTRUCTOR ATLAS, you don&apos;t start every class searching through
            videos, forums, blogs and old notes.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-[#1F4D3A] font-semibold flex items-center sm:justify-center gap-2" data-id="element-77" data-mp="355w0j1yphewa">
              <Check size={18} className="text-[#9C7726] shrink-0" aria-hidden="true" data-id="element-78" data-mp="2v6ewsq30lb2y" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-79" data-mp="3sskj7pvjhbdy">
            And with the five exclusive bonuses, you also have cocktail spec cards and recipe sheets, bar
            service lesson scripts, bar station training drills, jigger, free-pour and speed practice cards and
            bartending skills assessment rubrics with certificates to help you plan, teach, correct and assess
            your students.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-[#1F4D3A]" data-id="element-80" data-mp="ffsc32gr6b3g">
            YOU ALREADY HAVE <span className="text-[#9C7726]" data-id="element-81" data-mp="alo4cgznxz1b">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}